import React from 'react';
import { observer } from 'mobx-react';

import { RemoveLabel } from '../CartItemStyles';
import { classes } from '~utils/ClassNames';
import { RemoveIconWrapper } from '~theme/default-theme';
import { useTranslation } from '~sharedComponents/Providers/Translations/TranslationsHook';
import { TTranslations } from '~sharedComponents/Providers/Translations/TranslationsContext';

interface IRemoveButton {
    productName: string;
    removeTextButton: boolean;
    disabled?: boolean;
    onClick(): void;
    onKeyPress(event: React.KeyboardEvent<HTMLDivElement>): void;
}

export const removeClass = classes('cart-item-remove');

const RemoveButton = observer(
    ({ disabled, productName, removeTextButton, onClick, onKeyPress }: IRemoveButton) => {
        const translations = useTranslation(['removeLabel']);
        const { removeLabel } = translations || ({} as TTranslations);

        return (
            <div role="none" onClick={onClick} onKeyPress={onKeyPress} className={removeClass}>
                {removeTextButton && removeLabel ? (
                    <RemoveLabel
                        disabled={disabled}
                        data-test-id="overlay_remove_label"
                        tabIndex={0}
                        aria-label={`${productName} remove`}
                    >
                        {removeLabel}
                    </RemoveLabel>
                ) : (
                    <RemoveIconWrapper data-test-id="overlay_remove_icon" />
                )}
            </div>
        );
    }
);

export default RemoveButton;
